/**
 * Auto-generated by scripts/generate-drizzle-schema.mjs
 * Regenerate with: make generate-schema
 */

import { DrizzleAppSchema, type PowerSyncSQLiteDatabase } from "@powersync/drizzle-driver";
import { index, integer, sqliteTable, text } from "drizzle-orm/sqlite-core";
import type { InferInsertModel, InferSelectModel } from "drizzle-orm";

export const attachment = sqliteTable(
  "attachment",
  {
    id: text("id").primaryKey(),
    todo_id: text("todo_id"),
    filename: text("filename"),
    content_type: text("content_type"),
    size: integer("size"),
    url: text("url"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    list_id: text("list_id"),
    user_id: text("user_id"),
    is_shared: integer("is_shared"),
    hash: text("hash"),
  },
  (table) => [
    /** WHERE todo_id = ? ORDER BY created_at en useAttachments */
    index("attachment_by_todo").on(table.todo_id, table.created_at),
    /** WHERE user_id = ? en getHasLocalDataQuery */
    index("attachment_by_user").on(table.user_id),
  ],
);

export const font_family = sqliteTable("font_family", {
  id: text("id").primaryKey(),
  family: text("family"),
  name: text("name"),
  category: text("category"),
  is_active: integer("is_active"),
  sort_order: integer("sort_order"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
});

export const font_variant = sqliteTable("font_variant", {
  id: text("id").primaryKey(),
  font_family_id: text("font_family_id"),
  weight: text("weight"),
  url: text("url"),
  created_at: text("created_at"),
  attachment_id: text("attachment_id"),
});

// ⚡ Tabla con índice en user_id para acelerar getHasLocalDataQuery.
export const list = sqliteTable(
  "list",
  {
    id: text("id").primaryKey(),
    name: text("name"),
    color: text("color"),
    icon: text("icon"),
    user_id: text("user_id"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    theme_id: text("theme_id"),
    is_blur: integer("is_blur"),
    is_shared: integer("is_shared"),
    group_id: text("group_id"),
    follow_device_theme: integer("follow_device_theme"),
  },
  (table) => [
    /** WHERE user_id = ? en useLists y getHasLocalDataQuery */
    index("list_by_user").on(table.user_id),
  ],
);

// ⚡ Tabla con índice en user_id para acelerar getHasLocalDataQuery.
export const list_group = sqliteTable(
  "list_group",
  {
    id: text("id").primaryKey(),
    name: text("name"),
    user_id: text("user_id"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    color: text("color"),
    icon: text("icon"),
  },
  (table) => [
    /** WHERE user_id = ? en useListGroups y getHasLocalDataQuery */
    index("list_group_by_user").on(table.user_id),
  ],
);

export const list_group_item = sqliteTable(
  "list_group_item",
  {
    id: text("id").primaryKey(),
    list_id: text("list_id"),
    group_id: text("group_id"),
    added_at: text("added_at"),
    user_id: text("user_id"),
  },
  (table) => [
    /** LEFT JOIN list_group_item ON list.id = list_group_item.list_id en useLists() */
    index("list_group_item_by_list").on(table.list_id),
    /** WHERE group_id = ? ORDER BY added_at DESC en useGroupItems() */
    index("list_group_item_by_group").on(table.group_id, table.added_at),
  ],
);

// Dataset manejado por sync streams — índices no necesarios por ahora.
export const list_organization = sqliteTable("list_organization", {
  id: text("id").primaryKey(),
  list_id: text("list_id"),
  organization_id: text("organization_id"),
  added_at: text("added_at"),
  added_by: text("added_by"),
});

// Dataset pequeño por usuario — índices no necesarios por ahora.
export const member = sqliteTable("member", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  user_id: text("user_id"),
  role: text("role"),
  created_at: text("created_at"),
});

// Dataset pequeño — índices no necesarios por ahora.
export const organization = sqliteTable("organization", {
  id: text("id").primaryKey(),
  name: text("name"),
  slug: text("slug"),
  logo: text("logo"),
  metadata: text("metadata"),
  created_at: text("created_at"),
});

// Sesiones activas del usuario — dataset pequeño, sin índices.
export const session = sqliteTable("session", {
  id: text("id").primaryKey(),
  expires_at: text("expires_at"),
  token: text("token"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  ip_address: text("ip_address"),
  user_agent: text("user_agent"),
  user_id: text("user_id"),
  active_organization_id: text("active_organization_id"),
});

export const subtask = sqliteTable(
  "subtask",
  {
    id: text("id").primaryKey(),
    todo_id: text("todo_id"),
    text: text("text"),
    completed: integer("completed"),
    order: integer("order"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    list_id: text("list_id"),
    user_id: text("user_id"),
    is_shared: integer("is_shared"),
  },
  (table) => [
    /** WHERE todo_id = ? ORDER BY order, created_at en useSubtasks() */
    index("subtask_by_todo").on(table.todo_id, table.order, table.created_at),
    /** WHERE user_id = ? en getHasLocalDataQuery */
    index("subtask_by_user").on(table.user_id),
  ],
);

// Dataset global pequeño (~20 temas) — índices no necesarios.
export const themes = sqliteTable("themes", {
  id: text("id").primaryKey(),
  name: text("name"),
  background: text("background"),
  surface: text("surface"),
  accent: text("accent"),
  glow_colors: text("glow_colors"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  is_dark: integer("is_dark"),
  foreground: text("foreground"),
  field_background: text("field_background"),
  danger: text("danger"),
  success: text("success"),
  warning: text("warning"),
  muted: text("muted"),
  pattern_type: text("pattern_type"),
  pattern_opacity: integer("pattern_opacity"),
  pair_id: text("pair_id"),
  font_normal: text("font_normal"),
  font_medium: text("font_medium"),
  font_semibold: text("font_semibold"),
  font_bold: text("font_bold"),
  radius: text("radius"),
  surface_foreground: text("surface_foreground"),
  surface_secondary: text("surface_secondary"),
  surface_secondary_foreground: text("surface_secondary_foreground"),
  surface_tertiary: text("surface_tertiary"),
  surface_tertiary_foreground: text("surface_tertiary_foreground"),
  overlay: text("overlay"),
  overlay_foreground: text("overlay_foreground"),
  default: text("default"),
  default_foreground: text("default_foreground"),
  accent_foreground: text("accent_foreground"),
  field_foreground: text("field_foreground"),
  field_placeholder: text("field_placeholder"),
  field_border: text("field_border"),
  danger_foreground: text("danger_foreground"),
  success_foreground: text("success_foreground"),
  warning_foreground: text("warning_foreground"),
  segment: text("segment"),
  segment_foreground: text("segment_foreground"),
  border: text("border"),
  focus: text("focus"),
  link: text("link"),
  surface_shadow: text("surface_shadow"),
  overlay_shadow: text("overlay_shadow"),
  field_shadow: text("field_shadow"),
  muted_foreground: text("muted_foreground"),
  divider: text("divider"),
  glass_background: text("glass_background"),
  glass_border: text("glass_border"),
  glass_highlight: text("glass_highlight"),
  is_active: integer("is_active"),
  sort_order: integer("sort_order"),
});

// ⚡ Tabla más grande (~4500+ filas). Los índices aquí tienen el mayor impacto.
export const todo = sqliteTable(
  "todo",
  {
    id: text("id").primaryKey(),
    user_id: text("user_id"),
    text: text("text"),
    completed: integer("completed"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    list_id: text("list_id"),
    important: integer("important"),
    note: text("note"),
    due_date: text("due_date"),
    recurrence_rule: text("recurrence_rule"),
    my_day_date: text("my_day_date"),
    reminder_at: text("reminder_at"),
    is_shared: integer("is_shared"),
  },
  (table) => [
    /** JOIN todo ON list.id = todo.list_id en useLists() */
    index("todo_by_list").on(table.list_id, table.completed, table.updated_at),
    /** WHERE user_id = ? en queries globales de agregación */
    index("todo_by_user").on(table.user_id, table.completed, table.important),
    /** WHERE user_id = ? AND my_day_date IS NOT NULL AND my_day_date <= ? ORDER BY updated_at DESC en useMyDay() */
    index("todo_by_my_day").on(table.user_id, table.my_day_date, table.updated_at),
    /** WHERE due_date IS NOT NULL ORDER BY completed ASC, updated_at DESC en useTodos({ plannedOnly }) */
    index("todo_by_due_date").on(table.due_date, table.completed, table.updated_at),
    /** WHERE important = 1 ORDER BY completed ASC, updated_at DESC en useTodos({ importantOnly }) */
    index("todo_by_important").on(table.important, table.completed, table.updated_at),
    /** ORDER BY completed ASC, updated_at DESC en useTodos({ filter: 'all' }) */
    index("todo_by_global_sort").on(table.completed, table.updated_at),
    /** WHERE completed = 0 AND due_date > datetime('now') ORDER BY due_date ASC */
    index("todo_by_reminders").on(table.completed, table.due_date),
  ],
);

// Solo 1 fila por usuario — índices no necesarios.
export const user = sqliteTable("user", {
  id: text("id").primaryKey(),
  name: text("name"),
  email: text("email"),
  email_verified: integer("email_verified"),
  image: text("image"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  locale: text("locale"),
  global_theme_id: text("global_theme_id"),
  is_blur: integer("is_blur"),
  font_family: text("font_family"),
  follow_device_theme: integer("follow_device_theme"),
  role: text("role"),
  banned: integer("banned"),
  ban_reason: text("ban_reason"),
  ban_expires: text("ban_expires"),
  two_factor_enabled: integer("two_factor_enabled"),
  two_factor_secret: text("two_factor_secret"),
  two_factor_backup_codes: text("two_factor_backup_codes"),
});

export const drizzleSchema = {
  attachment,
  font_family,
  font_variant,
  list,
  list_group,
  list_group_item,
  list_organization,
  member,
  organization,
  session,
  subtask,
  themes,
  todo,
  user,
};

export const AppSchema = new DrizzleAppSchema(drizzleSchema);

export type Database = (typeof AppSchema)["types"];

/**
 * Type helper for the Drizzle database instance wrapped with PowerSync.
 */
export type PowerSyncDrizzleDB = PowerSyncSQLiteDatabase<typeof drizzleSchema>;

export const USER_DATA_TABLES = [
  "attachment",
  "list",
  "list_group",
  "list_group_item",
  "subtask",
  "todo",
] as const;

export type Attachment = InferSelectModel<typeof attachment>;
export type AttachmentInsert = InferInsertModel<typeof attachment>;
export type AttachmentRecord = Attachment;
export type FontFamily = InferSelectModel<typeof font_family>;
export type FontFamilyInsert = InferInsertModel<typeof font_family>;
export type FontFamilyRecord = FontFamily;
export type FontVariant = InferSelectModel<typeof font_variant>;
export type FontVariantInsert = InferInsertModel<typeof font_variant>;
export type FontVariantRecord = FontVariant;
export type List = InferSelectModel<typeof list>;
export type ListInsert = InferInsertModel<typeof list>;
export type ListRecord = List;
export type ListGroup = InferSelectModel<typeof list_group>;
export type ListGroupInsert = InferInsertModel<typeof list_group>;
export type ListGroupRecord = ListGroup;
export type ListGroupItem = InferSelectModel<typeof list_group_item>;
export type ListGroupItemInsert = InferInsertModel<typeof list_group_item>;
export type ListGroupItemRecord = ListGroupItem;
export type ListOrganization = InferSelectModel<typeof list_organization>;
export type ListOrganizationInsert = InferInsertModel<typeof list_organization>;
export type ListOrganizationRecord = ListOrganization;
export type Member = InferSelectModel<typeof member>;
export type MemberInsert = InferInsertModel<typeof member>;
export type MemberRecord = Member;
export type Organization = InferSelectModel<typeof organization>;
export type OrganizationInsert = InferInsertModel<typeof organization>;
export type OrganizationRecord = Organization;
export type Session = InferSelectModel<typeof session>;
export type SessionInsert = InferInsertModel<typeof session>;
export type SessionRecord = Session;
export type Subtask = InferSelectModel<typeof subtask>;
export type SubtaskInsert = InferInsertModel<typeof subtask>;
export type SubtaskRecord = Subtask;
export type Themes = InferSelectModel<typeof themes>;
export type ThemesInsert = InferInsertModel<typeof themes>;
export type ThemesRecord = Themes;
export type Todo = InferSelectModel<typeof todo>;
export type TodoInsert = InferInsertModel<typeof todo>;
export type TodoRecord = Todo;
export type User = InferSelectModel<typeof user>;
export type UserInsert = InferInsertModel<typeof user>;
export type UserRecord = User;
